import React, {Component} from 'react';
import {connect} from 'react-redux';
import CosCloud from 'cos-js-sdk-v4';
import axios from 'axios';
import qs from 'qs';
import {
    Mask,
    Tab,
    TabBody,
    NavBar,
    NavBarItem,
    ButtonArea,
    Button,
    MediaBox,
    MediaBoxBody,
    MediaBoxHeader,
    MediaBoxTitle,
    MediaBoxDescription,
    ActionSheet,
    LoadMore
} from 'react-weui';
import FileSelector from '../FileSelector'
import {TimeStream, getTimestamp} from '../../utils'

import '../../styles/classroom/ClassroomFilePanel.css'


class ClassroomFilePanel extends Component {
    BUCKET = 'static'
    APP_ID = '1253442168'
    REGION = 'gz'
    MY_FOLDER = 'material_doc/'

    constructor() {
        super()

        this.state = {
            items: [],
            filePath: '',
            fileName: '',
            fileExt: '',
            fileSize: 0,
            showMenu: false,
            menus: [],
            operatingItem: null,
            isSelected: false,
            loading: false,
        }
        this.handleUpload = this.handleUpload.bind(this)
        this.handleUploadSuccess = this.handleUploadSuccess.bind(this)
        this.handleUploadFail = this.handleUploadFail.bind(this)
        this.handleUploadProgress = this.handleUploadProgress.bind(this)
        this.handleChooseFile = this.handleChooseFile.bind(this)
        this.handleSendItem = this.handleSendItem.bind(this)
        this.handleDeleteItem = this.handleDeleteItem.bind(this)
        this.handleHideMenu = this.handleHideMenu.bind(this)
        this.handleHideFilePanel = this.handleHideFilePanel.bind(this)
        this.renderItem = this.renderItem.bind(this)
    }

    handleHideFilePanel() {
        this.props.dispatch({type: 'CLASSROOM_HIDE_FILE_PANEL'})
        this.setState({isSelected: false})
    }

    handleHideMenu() {
        this.setState({showMenu: false})
    }

    handleChooseFile(file, content) {
        let fileExt = String(file.name).split('.').pop().toLowerCase()
        let fileName = file.name
        let fileSize = file.size

        //支持以下格式：*.PDF、*.PPT、*.PPTX、*.XLS、*.XLSX、*.DOC、*.DOCX、*.TXT
        if (['pdf', 'ppt', 'pptx', 'xls', 'xlsx', 'doc', 'docx', 'txt'].indexOf(fileExt) === -1) {
            return this.context.page.showAlert('文件格式错误，支持格式为：*.PDF、*.PPT、*.PPTX、*.XLS、*.XLSX、*.DOC、*.DOCX、*.TXT');
        }

        // 判断文件大小100M
        if (fileSize / (1024 * 1024) > 100) {
            return this.context.page.showAlert('文件大小超出限制，请上传小于100M的文件')
        }

        // 不得上传空文件
        if (fileSize === 0) {
            return this.context.page.showAlert('文件内容不得为空，请重新上传')
        }

        this.context.page.showToast('上传中...', 'loading', false)
        let filePath = this.MY_FOLDER + String(Date.parse(new Date())) + '.' + fileExt
        this.setState({fileName, filePath, fileExt, fileSize})
        this.cos.uploadFile(
            this.handleUploadSuccess,
            this.handleUploadFail,
            this.handleUploadProgress,
            this.BUCKET,
            filePath,
            file,
            0
        )
    }

    handleSendItem() {
        this.setState({showMenu: false})
        const {operatingItem} = this.state

        const {timestampDelta} = this.props
        let timestamp = getTimestamp(timestampDelta)
        const data = {
            ts: timestamp
        }
        const url = `/api/classroom/${this.props.lectureId}/material/${operatingItem.id}/send`
        axios.post(url, qs.stringify(data)).then((response) => {
            if (response.data.code === 0) {
                this.context.page.showToast('发送成功')
            }
            if(response.data.code === 1){
                this.context.page.showAlert(response.data.msg)
            }
        })
    }

    handleDeleteItem() {
        this.setState({showMenu: false})
        const {operatingItem, items} = this.state
        const url = `/api/classroom/${this.props.lectureId}/material/${operatingItem.id}/delete`
        axios.post(url).then((response) => {
            if (response.data.code === 0) {
                this.setState({items: items.filter(m => m.id !== operatingItem.id)})
                this.context.page.showToast('删除成功')
            }
        })
    }

    handleFileClick(item) {
        const menus = []
        menus.push({
            label: '发送',
            onClick: this.handleSendItem
        })

        menus.push({
            label: '删除',
            className: 'danger',
            onClick: this.handleDeleteItem
        })
        this.setState({menus: menus, showMenu: true, operatingItem: item})
    }

    handleUpload() {
        if (window.systemType === 'ios' || /WindowsWechat/.test(navigator.userAgent)) {
            return this.context.page.showAlert('iOS手机和pc版微信不支持上传文件，请使用安卓手机或浏览器上传')
        }

        this.refs.file_selector.trigger()
    }

    handleUploadSuccess(res) {
        let {fileName, fileExt, filePath, fileSize, items} = this.state
        const {lectureId} = this.props
        axios.post(`/api/classroom/${lectureId}/material/upload_doc`, qs.stringify({
            filepath: filePath,
            file_name: fileName,
            file_format: fileExt,
            file_size: Number(fileSize / (1024 * 1024)).toFixed(2) === '0.00' ? '0.01' : Number(fileSize / (1024 * 1024)).toFixed(2)
        })).then(res => {
            if (res.data.code === 0) {
                let data = res.data.data
                this.context.page.hideLoading()
                this.context.page.showToast('上传成功')
                items.splice(0, 0, data)
                this.setState({items})
            }
            if(res.data.code === 1){
                this.context.page.hideLoading()
                this.context.page.showAlert(res.data.msg)
            }
        })
    }

    handleUploadFail(res) {
        this.page.showAlert('上传失败' + res.responseText || 'error')
    }

    handleUploadProgress() {
    }

    renderItem(item) {
        let docExt = item.content.doc_ext.toLowerCase()
        return (
            <MediaBox type="appmsg" key={item.id} onClick={this.handleFileClick.bind(this, item)}>
                <MediaBoxHeader>
                    <div className="file-type">
                        {'txt' === docExt &&
                        <i className="iconfont icon-TXT"/>
                        }
                        {['doc', 'docx'].indexOf(docExt) > -1 &&
                        <i className="iconfont icon-docx"/>
                        }
                        {['ppt', 'pptx'].indexOf(docExt) > -1 &&
                        <i className="iconfont icon-ppt"/>
                        }
                        {'pdf' === docExt &&
                        <i className="iconfont icon-PDF23"/>
                        }
                        {['xls', 'xlsx'].indexOf(docExt) > -1 &&
                        <i className="iconfont icon-xls1"/>
                        }
                    </div>
                </MediaBoxHeader>
                <MediaBoxBody>
                    <MediaBoxTitle>{item.content.doc_name}</MediaBoxTitle>
                    <MediaBoxDescription>{(Number(item.content.doc_size).toFixed(2) || '0') + 'M'}</MediaBoxDescription>
                    <MediaBoxDescription>{TimeStream(item.create_timestamp)}</MediaBoxDescription>
                </MediaBoxBody>
            </MediaBox>
        )
    }

    componentDidUpdate() {
        const {lectureId, showFilePanel} = this.props
        const {isSelected} = this.state
        if (showFilePanel && !isSelected) {
            this.setState({loading: true})
            this.setState({isSelected: true})
            axios.get(`/api/classroom/${lectureId}/material/list?type=doc&scope=liveroom`).then((response) => {
                if (response.data.code === 0) {
                    const {materials} = response.data.data
                    this.setState({items: materials, loading: false})
                }
            })
        }
    }

    componentDidMount() {
        const {lectureId} = this.props
        this.cos = new CosCloud({
            appid: this.APP_ID,
            bucket: this.BUCKET,
            region: this.REGION,
            getAppSign: (callback) => {
                axios.get(`/api/classroom/${lectureId}/material/add_doc_material_sign`).then(res => {
                    callback(res.data.data.signature)
                })
            },
            getAppSignOnce: (callback) => {
                axios.get(`/api/classroom/${lectureId}/material/add_doc_material_sign`).then(res => {
                    callback(res.data.data.signature)
                })
            }
        })
    }

    render() {
        const {showFilePanel} = this.props
        const {items, loading} = this.state

        if (!showFilePanel) {
            return null
        }

        return (
            <div className="classroom-file-panel-container">
                <FileSelector ref="file_selector" handleChoose={this.handleChooseFile}/>
                <Mask onClick={this.handleHideFilePanel}/>
                <div className="classroom-file-panel">
                    <ActionSheet
                        menus={this.state.menus}
                        actions={[{
                            label: '取消',
                            onClick: this.handleHideMenu
                        }]}
                        show={this.state.showMenu}
                        onRequestClose={this.handleHideMenu}
                    />

                    <Tab>
                        <NavBar>
                            <NavBarItem>
                                <div className="file-tips">
                                    上传的文件须小于100M，支持以下格式：*PDF、*PPT、*PPTX、*XLS、*XLSX、*DOC、*DOCX、*TXT
                                </div>
                            </NavBarItem>
                        </NavBar>
                        <TabBody>
                            {loading &&
                            <LoadMore loading>加载中...</LoadMore>
                            }
                            {items.map(item => {
                                return this.renderItem(item)
                            })}
                        </TabBody>
                        <div className="bottom-bar">
                            <ButtonArea>
                                <Button type="default" onClick={this.handleUpload}>上传文件</Button>
                            </ButtonArea>
                        </div>
                    </Tab>
                </div>
            </div>
        )
    }
}

ClassroomFilePanel.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    lectureId: state.classroom.lecture.id,
    showFilePanel: state.classroom.showFilePanel,
    timestampDelta: state.classroom.timestampDelta,
}))(ClassroomFilePanel)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomFilePanel.js